if (!customElements.get('product-page-modals')) {
    class ProductPageModalsElement extends HTMLElement {
        constructor() {
            super();
            this.initialized = false;
        }

        connectedCallback() {
            if (this.initialized) return;

            const modalId = this.dataset.modalId || '';
            if (!modalId) return;

            const modalElement = document.getElementById(modalId);
            if (!modalElement) return;

            // Setup tablist click handlers for when user clicks tabs inside the modal
            document.addEventListener('modal:open', (event) => {
                if (event.detail?.modal?.id !== modalId) return;
                
                const tablist = event.detail.modal.querySelector('accessibility-tablist');
                if (!tablist) return;

                tablist.addEventListener('tablist:activate', (e) => {
                    const activatedButton = e.detail?.button;
                    if (!activatedButton) return;

                    const activePanelId = activatedButton.getAttribute('aria-controls');
                    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
                    const modalContent = tablist.closest('[slot="modal-content"]') || event.detail.modal;

                    tabs.forEach((tab) => {
                        const panelId = tab.getAttribute('aria-controls');
                        const isActive = panelId === activePanelId;

                        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                        tab.setAttribute('tabindex', isActive ? '0' : '-1');

                        if (!panelId) return;
                        const panel = modalContent.querySelector(`#${panelId}`);
                        if (!panel) return;
                        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
                        panel.style.display = isActive ? '' : 'none';
                    });
                });
                // it the event.detail.triggerType matches aria-controls="modals-panel-11203824451848-template--28732668870920__main-tab-tracking-info" on the last part, we need to click on it.
                setTimeout(() => {
                    if (event.detail?.triggerType) {
                        const triggerButton = document.querySelector(`[aria-controls*="__main-tab-${event.detail?.triggerType}"]`);
                        if (triggerButton) {
                            triggerButton.click();
                        }
                    } 
                }, 200);
            });

            this.initialized = true;
        }
    }

    customElements.define('product-page-modals', ProductPageModalsElement);
}

